import head from 'lodash/head';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import featureFlagConstants from '~/common/helpers/featureFlagConstants';
import withHooks from '~/common/hoc/withHooks';
import useFeatureFlag from '~/common/hooks/useFeatureFlag';
import paths from '~/common/jsons/paths.json';

const SETTINGS_ITEMS_ORDER = [
  { role: 'GLOBAL:READ', path: paths.globals },
  { role: 'ACCOUNT:READ', path: paths.accounts },
  { role: 'APIKEY:READ', path: paths.api_keys },
  { role: 'RELATION:READ', path: paths.relationship },
  { role: 'REPLICA:READ', path: paths.multi_instance },
  { role: 'CAPSULE:READ', path: paths.capsule_headers },
  { role: 'CAPSULE:READ', path: paths.data_streaming }
];

const enhancer = withHooks(props => {
  const location = useLocation();
  const { acceptanceTerm, realms, application, authentication, acls } =
    useSelector(state => state);
  const dispatch = useDispatch();
  const { MONITOR_SETDEFAULTENVIRONMENT_FRONT, BUILD_GLOBALS } =
    featureFlagConstants;
  const { treatments } = useFeatureFlag([
    MONITOR_SETDEFAULTENVIRONMENT_FRONT,
    BUILD_GLOBALS
  ]);

  const enviromentDefault =
    treatments[MONITOR_SETDEFAULTENVIRONMENT_FRONT].treatment;

  function getEnvriomentByFeatureFlag(allEnviroment) {
    return allEnviroment.find(env => env === enviromentDefault);
  }

  function getEnvriomentByFeatureFlagRun(allEnviroment) {
    return allEnviroment.find(env => env === 'test');
  }

  const state = {
    allIds: realms?.result?.realms || [],
    byId: realms.entities.realms,
    activeRealm: application?.realm,
    user: authentication?.userData,
    scopes: acls?.scopes,
    environments: application?.environments?.allNames,
    eula: acceptanceTerm?.result
  };
  const actions = {
    setModalTwoFactor: dispatch.profile.setModalTwoFactor,
    setModalNewPassword: dispatch.profile.setModalNewPassword,
    onSignOut: dispatch.authentication.signOut,
    containPaths: paths =>
      paths?.reduce((result, path) => {
        if (!result) return location.pathname.indexOf(path) > -1;

        return result;
      }, false),
    goToDefaultLayout: () => {
      dispatch.router.navigate({ to: `/${state.activeRealm.realm}/pipelines` });
    },
    pathNameRuntime: () => {
      const envsWithAcl = (acc, current) => {
        const defaultAcl = ['GROUP:ADMIN', 'DEPLOYMENT:READ'];
        const acl = `DEPLOYMENT:READ{ENV=${current.toUpperCase()}}`;
        const roles = [...defaultAcl, acl];
        const isRole = state.scopes.find(r => roles.includes(r));

        if (isRole) return [...acc, current];

        return acc;
      };
      const envsAcl = state.environments.reduce(envsWithAcl, []);

      const newEnvironmentDefault = getEnvriomentByFeatureFlagRun(envsAcl);

      if (envsAcl.length > 0 && newEnvironmentDefault)
        return head([newEnvironmentDefault]);

      return head(state.environments);
    },
    goToSettings: () => {
      const { realm } = state.activeRealm;
      const isBuildGlobalsEnabled =
        treatments[BUILD_GLOBALS]?.treatment === 'on';

      // TODO: When removing BUILD_GLOBALS FF - 1) Remove this branch and always use
      // the dynamic logic below; 2) Remove BUILD_GLOBALS from useFeatureFlag; 3) Filter
      // GLOBAL:READ and ACCOUNT:READ from SETTINGS_ITEMS_ORDER (or remove from constant)
      if (!isBuildGlobalsEnabled) {
        dispatch.router.navigate({ to: `/${realm}${paths.globals}` });
        return;
      }

      const scopes = state.scopes || [];
      const itemsToConsider = SETTINGS_ITEMS_ORDER.filter(
        ({ role }) => role !== 'GLOBAL:READ' && role !== 'ACCOUNT:READ'
      );

      const hasRole = role =>
        scopes.some(
          scope =>
            scope === role ||
            (scope.includes('{ENV') && scope.split('{ENV')[0] === role)
        );

      const firstItem = itemsToConsider.find(({ role }) => hasRole(role));
      const path = firstItem
        ? `/${realm}${firstItem.path}`
        : `/${realm}${paths.settings}`;

      dispatch.router.navigate({ to: path });
    },
    goToAdmin: () => {
      dispatch.router.navigate({
        to: `/${state.activeRealm.realm}/settings/beta/user`
      });
    },
    goToConnectivity: () => {
      dispatch.router.navigate({
        to: `/${state.activeRealm.realm}/connectivity/edge-routers`
      });
    },
    getEnvriomentByFeatureFlag
  };

  return {
    ...props,
    ...state,
    ...actions
  };
});

export default enhancer;
